import {useForgotPasswordContext} from "../context/ForgotPasswordContextProvider";
import {ForgotPasswordContinuationForm} from "./ForgotPasswordContinuationForm";
import {ForgotPasswordVerificationForm} from "./ForgotPasswordVerificationForm";
import {ResetPasswordForm} from "./ResetPasswordForm";
import {InvalidLink} from "./InvalidLink";
import React from "react";
import {LoadingIcon} from "@gs-ux-uitoolkit-react/loading";

function getSignInRedirectUrl(): string {
    const domain = window.location.hostname;

    if (domain.includes('dev.custodysolutions')) {
        return 'https://dev.custodysolutions.site.gs.com/client-app/';
    } else if (domain.includes('qa.custodysolutions')) {
        return 'https://qa.custodysolutions.site.gs.com/client-app/';
    } else if (domain.includes('uat.custodysolutions')) {
        return 'https://uat.custodysolutions.gs.com/client-app/';
    } else if (domain.includes('custodysolutions')) {
        return 'https://custodysolutions.gs.com/client-app/';
    }

    return '/sign-in';
}

export function ForgotPasswordContent() {
    const {forgotPasswordAttempt} = useForgotPasswordContext();
    let content = null;
    const forgotPasswordSessionId = sessionStorage.getItem('forgotPasswordSessionId');

    if (!forgotPasswordAttempt){
        content =<LoadingIcon />;
    } else if (forgotPasswordAttempt != null && forgotPasswordAttempt.isCorrectForgotPasswordSessionId != 1) {
        content = <InvalidLink/>;
    } else if (forgotPasswordAttempt.isThirdPartyAgent == 1 && forgotPasswordAttempt.isMfaSecretSent == 1
        && forgotPasswordAttempt.isVerificationComplete != 1) {
        content = <ForgotPasswordVerificationForm/>;
    } else if (forgotPasswordAttempt.isThirdPartyAgent == 1 && forgotPasswordAttempt.isVerificationComplete == 1
        && forgotPasswordAttempt.isPasswordResetComplete != 1) {
        content = <ResetPasswordForm/>;
    } else if (forgotPasswordAttempt.isThirdPartyAgent == 1 && forgotPasswordAttempt.isVerificationComplete == 1
        && forgotPasswordAttempt.isPasswordResetComplete == 1) {
        window.location.href = getSignInRedirectUrl();
    } else if (!forgotPasswordAttempt || forgotPasswordAttempt.isMfaSecretSent != 1) {
        content = <ForgotPasswordContinuationForm/>;
    } else if (!forgotPasswordAttempt || forgotPasswordAttempt.isVerificationComplete != 1) {
        content = <ForgotPasswordVerificationForm/>;
    } else if (forgotPasswordAttempt.isVerificationComplete == 1
        && forgotPasswordAttempt.isPasswordResetComplete == 0) {
        content = <ResetPasswordForm/>;
    } else if ( forgotPasswordAttempt.isVerificationComplete == 1
        && forgotPasswordAttempt.isPasswordResetComplete == 1) {
        window.location.href = getSignInRedirectUrl();
    }
    return content;
}